import { defineMessages } from 'react-intl'

const messages = {
  accept: {
    id: 'app.components.product-item-controls.accept',
    defaultMessage: 'Accept',
  },
  decline: {
    id: 'app.components.product-item-controls.decline',
    defaultMessage: 'Decline',
  },
  print: {
    id: 'app.components.product-item-controls.print',
    defaultMessage: 'Print',
  },
  printAwaitingFinalPoTooltip: {
    id: 'app.components.product-item-controls.print-awaiting-final-po-tooltip',
    defaultMessage: 'The label includes the final purchase order — cannot print until it is received.',
  },
}

export default defineMessages(messages)
